<template>
  <div v-if="!showRequest">
    <app-history @clicked="$router.push('/tahsil-history')" />
    <v-card class="fullForm">
      <div class="fullText">
        <h3>شرایط اولیه مجوز تحصیل همزمان:</h3>
        <br />
        <ol>
          <li>
            درخواست می بایست بعد از قبولی در آزمون دانشگاه مورد نظر (کنکور)
            باشد.
          </li>
          <li>
            دارای پرونده فعال آموزشی در حوزه های علمیه استان خراسان بزرگ باشد.
          </li>
          <li>داشتن حداقل مدرک سطح2 حوزه علمیه</li>
          <li>سابقه تخلف یا کمیسیون در مدرسه یا مرکز مدیریت نداشته باشد</li>
          <li>
            رشد تحصیلی متناسب با برنامه های آموزشی حوزه علمیه داشته باشد (عدم
            عقب افتادگی تحصیلی ، انتخاب درس و کسب نمره قبولی در تمامی دروس
            انتخابی هر سال تحصیلی )
          </li>
          <li>
            قبولی در رشته ها و کرایش های تحصیلی متناسب با اهداف و رسالت های حوزه
            علمیه
          </li>
          <li>
            توانایی تحصیل همزمان در حوزه و دانشگاه داشته باشد.
            <br />
            <br />
            <b>تبصره: </b>
            از ملاک های توانایی تحصیل همزمان: 1. نداشتن عقب افتادگی تحصیلی 2-
            همجواری دانشگاه و مدرسه محل تحصیل 3- عدم تداخل برنامه های درسی حوزه
            با دانشگاه می باشد.
          </li>
        </ol>
        <br />
        <h3>تعهد نامه متقاضیان تحصیل همزمان حوزه و دانشگاه:</h3>
        <br />
        <ol>
          <li>
            رعایت شئون روحانیت و مقررات حوزه همراه با فعالیتهاي حوزوي در مدت
            تحصیل در دانشگاه و بعد از فراغت از تحصیل.
          </li>
          <li>تحصیل در حوزه علمیه طبق برنامه آموزشی مرکز مدیریت</li>
          <li>
            قبول ماموریت از طرف مرکز مدیریت پس از فارغ التحصیلی از دانشگاه بمدت
            سنوات تحصیل در دانشگاه
          </li>
          <li>اعلام فارغ التحصیلی یا انصراف از دانشگاه به مرکز مدیریت</li>
          <li>
            این درخواست صرفا برای یک دانشگاه،رشته تحصیلی و مقطع تحصیلی می باشد
            در صورتی که دانشگاه، رشته یا مقطع تغییر کرد باید درخواست مجدد ارسال
            تا بررسی شود
          </li>
          <li>
            در صورت تخلف از موارد فوق مرکز مدیریت می تواند نسبت به قطع کلیه
            مزایا ، خدمات و عدم ادامه تحصیل در دانشگاه، اینجانب اقدام نموده و
            شرعا ملزم به جبران تمامی خدمات دریافتی از حوزه در طول تحصیل می باشم.
          </li>
        </ol>
      </div>
      <br />
      <br />
      <div style="width: 100%">
        <v-simple-checkbox v-model="showNext" :ripple="false"></v-simple-checkbox>
        <b>موارد فوق را با دقت مطالعه كردم و نسبت به رعایت آن متعهد مي شوم.</b>
      </div>
    </v-card>
    <div class="confirm">
      <v-btn class="register" v-if="showNext" :class="!isMobile ? 'btnMargin' : ''" color="primary white--text" rounded
        @click="handleShowRequest">
        مرحله بعد
      </v-btn>
    </div>
  </div>
  <div v-else>
    <v-card class="form">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>تاریخ شروع تحصیل در دانشگاه:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-btn class="form-center" color="orange white--text" rounded @click="onClickDate(1)">
            {{ startSelected ? startDate : "انتخاب تاریخ" }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>تاریخ اتمام مقطع تحصیلی دانشگاهی:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-btn class="form-center" color="orange white--text" rounded @click="onClickDate(2)">
            {{ endSelected ? endDate : "انتخاب تاریخ" }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="2">
          <b>استان:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <v-select :items="ostans" item-text="OstanName" item-value="OstanID" v-model="selectedOstan"
            @change="getCities" no-data-text="داده ای برای نمایش وجود ندارد."></v-select>
        </v-col>

        <v-col class="d-flex" cols="12" sm="2">
          <b>شهر:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <v-select :items="cities" item-text="ShahrestanName" item-value="id" v-model="cityID"
            no-data-text="داده ای برای نمایش وجود ندارد."></v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>نام موسسه / دانشگاه:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="location"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> <b>رشته:</b> </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="field"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="3"><b> نوع تحصیل </b></v-col>
        <v-col class="d-flex ltr" cols="9">
          <v-radio-group v-model="isHozoori" row>
            <v-radio label="مجازی" value="0"></v-radio>
            <v-radio label="حضوری" value="1"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>توضیحات:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="comment" no-resize></v-textarea>
        </v-col>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="6">
            <v-file-input label="مستندات قبولی در دانشگاه" v-model="image"></v-file-input>
          </v-col>
        </v-row>
      </v-row>

      <v-row class="ltr">
        <v-btn color="primary white--text" class="register" rounded @click="applyRequest" :disabled="apiRunning">
          {{ apiRunning ? "لطفا منتظر بمانید..." : "ثبت" }}
        </v-btn>
      </v-row>
    </v-card>
    <date-picker ref="datepicker1" v-model="startDate" :editable="false" :auto-submit="true" element="fileInput1"
      @change="onChangeDate($event, 1)"></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <date-picker ref="datepicker2" v-model="endDate" :editable="false" :auto-submit="true" element="fileInput2"
      :min="startDate" @change="onChangeDate($event, 2)"></date-picker>
    <input id="fileInput2" ref="fileInput2" />
  </div>
</template>

<script>
import { getOstans, getShahr } from "@/api/location";
import { saveRequest } from "@/api/tahsil";
import { TODAY } from "@/utils/constants";
import HistoryButton from "@/components/HistoryButton";
import moment from "moment-jalaali";
export default {
  data() {
    return {
      today: TODAY,
      showRequest: false,
      showNext: false,
      startDate: TODAY,
      endDate: TODAY,
      startSelected: false,
      endSelected: false,
      location: "",
      field: "",
      isHozoori: "1",
      ostans: [],
      cities: [],
      selectedOstan: -1,
      cityID: -1,
      comment: "",
      image: null,
    };
  },
  components: {
    appHistory: HistoryButton,
  },
  methods: {
    getOstan() {
      return new Promise((resolve, reject) => {
        getOstans()
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.ostans = response.data;
            this.selectedOstan = this.ostans[0].OstanID;
            this.getCities();
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCities() {
      this.cityID = -1;
      return new Promise((resolve, reject) => {
        getShahr(this.selectedOstan)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.cities = response.data;
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    onChangeDate($event, input) {
      let date = moment($event).format("jYYYY/jMM/jDD");
      if (input == 1) {
        this.startDate = date;
        this.startSelected = true;
      } else {
        this.endDate = date;
        this.endSelected = true;
      }
    },
    /**
     * check user input and  then send khorooj request
     */
    applyRequest() {
      var text = "";
      if (!this.endSelected) {
        this.endDate = "";
      }
      if (!this.startSelected) {
        text = "لطفا زمان شروع را انتخاب کنید.";
        // } else if (!this.endSelected) {
        //   text = "لطفا زمان پایان را انتخاب کنید.";
      } else if (this.startDate > this.endDate && this.endSelected) {
        text = "زمان شروع بایستی پیش از زمان پایان باشد.";
      } else if (this.cityID == -1) {
        text = "شهر انتخاب نشده است.";
      } else if (this.location == "") {
        text = "نام موسسه مقصد انتخاب نشده است.";
      } else if (this.field == "") {
        text = "رشته انتخاب نشده است.";
      } else if (this.image == null) {
        text = " مستندات قبولی در دانشگاه بایستی انتخاب شود.";
      }

      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        saveRequest(
          this.image,
          this.startDate,
          this.endDate,
          this.cityID,
          this.location,
          this.field,
          this.isHozoori == "1",
          this.comment
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
            this.$store.commit("SET_API_RUNNING", false);
            if (data.Success) {
              this.goToIndex();
            }
          })

          .catch((error) => {
            this.$store.commit("SET_API_RUNNING", false);
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
    goToIndex() {
      this.$router.push({ path: "/tahsil-history" });
    },
    handleShowRequest() {
      window.scrollTo(0, 0)
      this.$router.push({
        query: {

          showRequest: "true"
        }
      });

    }
  },
  /**
   * get khorooji meta data
   */
  created() {
    if (this.$route.query.showRequest) {
      this.$router.replace({
        query: {}
      })
    }
    this.getOstan();
  },
  computed: {
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  watch: {

    '$route'(to, from) {
      this.showRequest = !!this.$route.query.showRequest;

    }
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}

.request {
  width: 300px !important;
  margin: 15px;
}

.register {
  margin: 30px 15px 15px;
}

.v-simple-checkbox {
  margin: 2px 0 0 5px;
  float: right;
}

.v-input--is-label-active {
  width: 100%;
}

@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}

.fullForm {
  margin-bottom: 80px;
}
</style>
<style>
.v-input--switch__thumb {
  color: gray !important;
}
</style>
